module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_XHC.0bc242da.png";